import { unique_entity_id } from './entityIdFromName';

/**
 * Scan other ticket types and pricing lists for a pricing id shared with the
 * one currently being made independent, so the UI can warn about the impact
 * of decoupling its stock quota from that shared pool.
 *
 * @param {string} pricingId
 * @param {object} currentTickettype
 * @param {object[]} tickettypes
 * @param {object[]} pricinglists
 * @return {{ tickettypes: object[], pricinglists: object[] }}
 */
export function findSharedPricingIdUsages(pricingId, currentTickettype, tickettypes, pricinglists) {
    const matchingTickettypes = (tickettypes || [])
        .filter(tt => tt && String(tt._id) !== String(currentTickettype?._id))
        .filter(tt => (
            !!tt.pricings?.[pricingId]
            || !!tt.rules?.stocks?.overrides?.[pricingId]
        ))
        .map(tt => ({
            _id: tt._id,
            name: tt.name,
            max_quantity: tt.rules?.stocks?.overrides?.[pricingId]?.max_quantity ?? null,
            independent_of_tickettype: !!tt.rules?.stocks?.overrides?.[pricingId]?.independent_of_tickettype,
        }));

    const matchingPricinglists = (pricinglists || [])
        .filter(pl => !!pl?.pricings?.[pricingId])
        .map(pl => ({
            _id: pl._id,
            name: pl.name,
        }));

    return {
        tickettypes: matchingTickettypes,
        pricinglists: matchingPricinglists,
    };
}

export function hasSharedPricingIdUsages(matches) {
    return (matches?.tickettypes?.length || 0) > 0 || (matches?.pricinglists?.length || 0) > 0;
}

/**
 * Suggest a new, unused pricing id to disambiguate a pricing shared across
 * ticket types/pricing lists (e.g. `adult` -> `adult_2`).
 */
export function suggestDisambiguatedPricingId(pricingId, takenIds) {
    return unique_entity_id(String(pricingId || '').trim(), takenIds || []);
}
